import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";

export const useFedexAgreement = () => {
  const team = useRequiredContext(TeamContext);

  const hasAcceptedFedexAgreement =
    team?.settings?.outboundLabels?.hasAcceptedFedexAgreement ?? false;

  const isFedexEnabled =
    team?.settings?.outboundLabels?.enabledCarrierAccounts
      ?.directToCarrierIntegrations?.fedex ?? false;

  return {
    shouldShowFedexAgreementLink: isFedexEnabled && !hasAcceptedFedexAgreement,
  };
};
